module.exports = __webpack_public_path__ + "img/05.1a23f5d3.png";